/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
import classNames from 'classnames'
import { ContentBadgeProps } from './ContentBadge.types'
import styles from './ContentBadge.module.scss'

const ContentBadge = (props: ContentBadgeProps): JSX.Element => {
  const { children, variant, onClickEvent, ...rest } = props
  return (
    <div
      data-testid="content-badge"
      className={classNames(styles.wrapper, variant ? styles[variant] : undefined)}
      {...rest}
      onClick={onClickEvent ? () => onClickEvent() : undefined}
    >
      {children}
    </div>
  )
}
export default ContentBadge
